"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineTableFieldContext = void 0;
const react_1 = require("react");
exports.InlineTableFieldContext = react_1.createContext({
    withRemove: true,
    initNewItem: () => ({}),
});
//# sourceMappingURL=inline-table-context.js.map